import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
const STORAGE_KEY = 'cherub_countdown_end';
const DURATION_MS = 24 * 60 * 60 * 1000;
function getEndTime() {
  try {
    const existing = sessionStorage.getItem(STORAGE_KEY);
    if (existing) return parseInt(existing, 10);
    const end = Date.now() + DURATION_MS;
    sessionStorage.setItem(STORAGE_KEY, String(end));
    return end;
  } catch {
    return Date.now() + DURATION_MS;
  }
}
function pad(n: number) {
  return n.toString().padStart(2, '0');
}
function Digit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="text-center" data-id="element-32">
      <div className="relative font-mono font-bold text-gold text-[2.4rem] min-w-[64px] rounded-lg py-2 px-3 overflow-hidden" style={{
      background: 'rgba(240,192,64,0.1)'
    }} data-id="element-33">
        <AnimatePresence mode="popLayout" initial={false} data-id="element-34">
          <motion.span key={value} initial={{
          y: -28,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: 28,
          opacity: 0
        }} transition={{
          duration: 0.35,
          ease: 'easeOut'
        }} className="inline-block" data-id="element-35">
            {value}
          </motion.span>
        </AnimatePresence>
      </div>
      <span className="text-[0.65rem] text-white/45 uppercase tracking-[0.1em] mt-1.5 block" data-id="element-36">
        {label}
      </span>
    </div>;
}
export function Countdown() {
  const [time, setTime] = useState({
    h: '23',
    m: '59',
    s: '00'
  });
  useEffect(() => {
    const tick = () => {
      const end = getEndTime();
      const distance = end - Date.now();
      if (distance <= 0) {
        setTime({
          h: '00',
          m: '00',
          s: '00'
        });
        return;
      }
      const h = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const m = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      const s = Math.floor(distance % (1000 * 60) / 1000);
      setTime({
        h: pad(h),
        m: pad(m),
        s: pad(s)
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);
  return <div className="bg-white/5 border border-gold/25 rounded-xl p-6 mb-9" data-id="element-37">
      <p className="text-[0.75rem] tracking-[0.15em] uppercase text-white/50 mb-4" data-id="element-38">
        ⏱ Este precio desaparece en:
      </p>
      <div className="flex justify-center gap-4 items-start" data-id="element-39">
        <Digit value={time.h} label="Horas" data-id="element-40" />
        <span className="text-[2rem] text-gold/40 self-start mt-1" data-id="element-41">:</span>
        <Digit value={time.m} label="Minutos" data-id="element-42" />
        <span className="text-[2rem] text-gold/40 self-start mt-1" data-id="element-43">:</span>
        <Digit value={time.s} label="Segundos" data-id="element-44" />
      </div>
    </div>;
}